import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-chevron-down",
  templateUrl: "./chevron-down.component.html",
  styleUrls: ["./chevron-down.component.scss"],
})
export class ChevronDownComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
